import { render, staticRenderFns } from "./SgsLeft.vue?vue&type=template&id=59d32c9b&scoped=true"
import script from "./SgsLeft.vue?vue&type=script&lang=js"
export * from "./SgsLeft.vue?vue&type=script&lang=js"
import style0 from "./SgsLeft.vue?vue&type=style&index=0&id=59d32c9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d32c9b",
  null
  
)

export default component.exports